import { render, staticRenderFns } from "./AppM.vue?vue&type=template&id=289cadac&"
import script from "./AppM.vue?vue&type=script&lang=js&"
export * from "./AppM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports